import * as PromoCode from '../../actions/promoCode/index.js';

const initialState = {
    error: undefined,
    success: false
}

export default function promoCode(state = initialState, action = {}) {
    switch (action.type) {
        case PromoCode.SUCCESS_FETCH_PROMOCODE_ACTIVATE:
            if(action.data.Result === 0) {
                return {
                    ...state,
                    success: true,
                    error: undefined
                };
            }
            if (action.data.Error === undefined) {
                return {
                    ...state,
                    error: -1,
                    success: false
                };
            } else {
                return {
                    ...state,
                    error: action.data.Error,
                    success: false
                };
            }

        case PromoCode.FAILURE_FETCH_PROMOCODE_ACTIVATE:
            return {
                ...state,
                error: -1,
                success: false
            };
        
        case PromoCode.FETCH_PROMOCODE_ACTIVATE:
            return {
                ...state,
                error: undefined,
                success: false
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./js/shared/reducers/promoCodeReducer.js